import moment, { Moment } from 'moment';
import React from 'react';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import useFilters from '../../../Base/Hooks/useFilters';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
import { useAppContext } from '../../../../Services/AppContext';

export interface FilledQuestionnaireFilterValues {
	dateFrom?: Moment | string;
	dateTo?: Moment | string;
	scheduledByIds?: string[];
	patientId?: string;
	questionnaireId?: string;
	questionnaireCode?: string;
	workplaceIds?: string[];
	result?: string;
	seen?: boolean;
}

interface FilledQuestionnaireFilterProps {
	onFilter: (values: FilledQuestionnaireFilterValues) => void;
}

const FilledQuestionnaireFilter: React.FC<FilledQuestionnaireFilterProps> = ({
	onFilter,
}) => {
	const { isLatam } = useAppContext();
	const {
		checkEmptyString,
		handleQuestionnaireSeenFilter,
		handleMultiSelectValue,
	} = useFilters();

	const onFilterData = (values: any) => {
		const filter: FilledQuestionnaireFilterValues = {
			dateFrom: values?.dateFrom
				? moment(values.dateFrom).format('YYYY-MM-DD')
				: undefined,
			dateTo: values?.dateTo
				? moment(values.dateTo).format('YYYY-MM-DD')
				: undefined,
			scheduledByIds: handleMultiSelectValue(values?.doctorIds),
			patientId: values?.patient
				? checkEmptyString(values.patient.value)
				: undefined,
			questionnaireId: values?.questionnaire
				? checkEmptyString(values.questionnaire.value)
				: undefined,
			questionnaireCode: values?.questionnaireCode
				? checkEmptyString(values.questionnaireCode.value)
				: undefined,
			workplaceIds: handleMultiSelectValue(values?.workplaceIds),
			result: values?.questionnaireResult
				? values.questionnaireResult.value
				: undefined,
			seen: handleQuestionnaireSeenFilter(values?.questionnaireSeen?.value),
		};

		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={(values: any) => onFilterData(values)}
			storageKey={GRID_FILTER_KEYS.FILLED_QUESTIONNAIRES_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={170}
				customLabel='base.shared.from'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_TO}
				width={170}
				customLabel='base.shared.to'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_IDS}
				width={330}
				customLabel='component.questionnaires.byWhichDoctor'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.QUESTIONNAIRE_ID}
				customLabel='base.monitoring'
				width={350}
				visible={!isLatam}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.QUESTIONNAIRE_CODE}
				customLabel='base.monitoring'
				width={350}
				visible={isLatam}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.WORKPLACES}
				width={350}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.QUESTIONNAIRE_RESULT}
				width={350}
				visible={!isLatam}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.QUESTIONNAIRE_SEEN}
				width={280}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default FilledQuestionnaireFilter;
